const clientConfig = {
	siteUrl: 'https://online.youngengineers.org/db',
	ProgramsUrl:'https://online.youngengineers.org',
	AUTH_KEY: 'zm6Bm=/:9F(k;b]i>l^/@s0hlkbfD2pkAW9r}°VM~1d!^hDh$0GnBpFM=@alOq:Q'
};

export default clientConfig;
